import api from './api';

export default {
  async getDictionary()  {
      return await api.get('DictionaryApi/GetDictionaryItems');
  },
}
